import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export const useInitialTokenAmount = () => {
  const queryClient = useQueryClient();

  const { data: initialAmount, isLoading, error: fetchError } = useQuery({
    queryKey: ['initialTokenAmount'],
    queryFn: async () => {
      console.log('Fetching initial token amount');
      const { data, error } = await supabase
        .from('system_settings')
        .select('setting_value')
        .eq('setting_key', 'initial_token_amount')
        .maybeSingle();
      
      if (error) {
        console.error('Error fetching initial token amount:', error);
        throw error;
      }

      console.log('Initial token amount fetched:', data);
      return data?.setting_value;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (newAmount: string) => {
      console.log('Updating initial token amount to:', newAmount);
      const { data, error } = await supabase
        .from('system_settings')
        .update({ setting_value: newAmount })
        .eq('setting_key', 'initial_token_amount')
        .select('setting_value')
        .maybeSingle();
      
      if (error) {
        console.error('Error updating initial token amount:', error);
        if (error.code === '42501') {
          throw new Error('You need admin privileges to update this setting');
        }
        throw error;
      }

      if (!data) {
        throw new Error('Failed to update initial token amount');
      }
      
      console.log('Initial token amount updated successfully:', data);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['initialTokenAmount'] });
    },
  });

  return {
    initialAmount,
    isLoading,
    fetchError,
    updateMutation,
  };
};